export default [
  "blackfriday2021",
  "blackfriday2022",
  "blackfriday2023",
  "blackfriday2024",
  "qa3",
  "personal",
];
